import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { sendPasswordReset } from '../auth/passwordReset';
import { HybridIcon } from '../components/HybridIcon';
import './Auth.css';

export default function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!email.trim()) {
      setError('Please enter your email address');
      return;
    }

    setLoading(true);
    setError(null);
    
    try {
      const result = await sendPasswordReset({ email });
      if (result.success) {
        setSuccess(true);
      } else {
        setError(result.error || 'Failed to send password reset email');
      }
    } catch (err) {
      setError((err as Error).message);
    } finally {
      setLoading(false);
    }
  };

  if (success) {
    return (
      <div className="auth-container">
        <div className="auth-content">
          <div className="auth-header">
            <HybridIcon name="mail" size={64} color="#f4511e" />
            <h1 className="auth-title">Check Your Email</h1>
            <p className="auth-subtitle">Password Reset Sent</p>
          </div>

          <div className="auth-message">
            <p>We've sent a password reset link to:</p>
            <p className="auth-email-display">{email}</p>
            <p className="auth-message-text">
              Please check your inbox and click the link to reset your password.
              If you don't see the email, check your spam folder.
            </p>
          </div>

          <div className="auth-footer">
            <Link to="/login" className="auth-link">Back to Login</Link>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="auth-container">
      <div className="auth-content">
        <div className="auth-header">
          <HybridIcon name="lock-closed" size={64} color="#f4511e" />
          <h1 className="auth-title">Forgot Password</h1>
          <p className="auth-subtitle">Enter your email to reset your password</p>
        </div>

        <form className="auth-form" onSubmit={handleSubmit}>
          {error && (
            <div className="auth-error">
              <HybridIcon name="alert-circle" size={20} color="#d32f2f" />
              <span>{error}</span>
            </div>
          )}

          <div className="auth-input-group">
            <HybridIcon name="mail" size={20} color="#666" className="auth-input-icon" />
            <input
              type="email"
              placeholder="Email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="auth-input"
              disabled={loading}
              required
            />
          </div>

          <button
            type="submit"
            className="auth-button auth-button-primary"
            disabled={loading}
          >
            {loading ? (
              <div className="spinner-small" />
            ) : (
              'Send Reset Link'
            )}
          </button>

          <div className="auth-footer">
            <Link to="/login" className="auth-link">Back to Login</Link>
          </div>
        </form>
      </div>
    </div>
  );
}

